import React, {ChangeEvent, useState, KeyboardEvent} from "react";
import * as Styled from "./ForgotPasswordPageCompStyled"
import InputComp from "../buttons/inputComp/InputComp";
import ContinueButton from "../generalButtons/ContinueButton";
import RegisterNow from "../generalButtons/RegisterNow";
import TextArea from "../textArea/TextArea";
import {ApiResetPassword} from "../../api/PasswordServices";
import Image from "next/image";
import ReturnHomePage from "../generalButtons/ReturnHomePage";
import Link from "next/dist/client/link";
import {NavigationURLs} from "../../functions/NavigationFunctions";
import CustomAlert, {AlertType} from "../customAlert/CustomAlert";
import ReturnLoginPage from "../generalButtons/ReturnLoginPage";
import {isValidEmail} from "../../utils/ValidEmail";

const changeWriting = (e: ChangeEvent<HTMLInputElement>) => {
    // console.log(e.target.value);
}

const ForgotPageComp = () => {

    const [email, setEmail] = useState('');
    const [preventAction, setPreventAction] = useState(false);

    const [successFullSent, setSuccessFullSent] = useState(false);

    const [alert, setAlert] = useState<{ message: string; type: AlertType } | null>(null);

    const [isRequested, setIsRequested] = useState(false);

    const handleAlertClose = () => {
        setAlert(null);
    };

    const startForgotPassword = async (email: string) => {

        if (preventAction) {
            return;
        }

        try {
            await ApiResetPassword(email).then((response) => {
                setPreventAction(false);
                // setSuccessFullSent(true);
                setIsRequested(true);
                setAlert({message: response !== null ? response : '<span class="color-text-warning">Teşekkürler! </span> <span> Yeni şifre talebiniz e-posta / telefon adresinize başarıyla gönderilmiştir</span>' , type: 'success'});
                return response;
            }).catch((error: string) => {
                setAlert({message: error, type: 'fail'});
                setPreventAction(false);
                return error;
            });
        } catch (error: any) {
            setPreventAction(false);
            setAlert({message: error, type: 'fail'});
        }
    };

    const alertValidate = ()=>{
        if (email === '') {
            handleAlertClose();
            setAlert({message: '<span class="color-text-warning">Hata! </span> <span> Form alanı boş bırakılamaz.</span> </br> <span class="text-thin">Lütfen doğru bilgiyi giriniz.</span>', type: 'fail'});
        } else if (!email) {
            handleAlertClose();
            setAlert({message: '<span class="color-text-warning">Hata! </span> <span> Böyle bir email adresi bulunamadı.</span> </br> <span class="text-thin">Lütfen doğru email adresini giriniz.</span>', type: 'fail'});
        } else {
            startForgotPassword(email).then();
        }
    }

    // if(successFullSent){
    //     return (
    //         <React.Fragment>
    //             <Styled.ForgotPassword2Wrapper>
    //                 <Styled.ForgotPassword2Content>
    //                     <Styled.TitleComp>
    //                         <Styled.ForgotPassword2Title>
    //                             YENİ ŞİFRE İSTEĞİ
    //                         </Styled.ForgotPassword2Title>
    //                     </Styled.TitleComp>
    //                     <Styled.ForgotPassword2Detail>
    //                         <Styled.ForgotPassword2FormTriangle/>
    //                         <TextArea>
    //                             <h2>
    //                                 Şifre yenileme adresi e-postanıza gönderildi
    //                             </h2>
    //                             <Styled.ForgotPassword2Icon>
    //                                 <Image src={'/next/assets/images/forgot-password/success-forgot-password.png'} width={142} height={128} alt={'pembe panjur sifre sıfırlama'}/>
    //                             </Styled.ForgotPassword2Icon>
    //                         </TextArea>
    //                     </Styled.ForgotPassword2Detail>
    //                     <Styled.ReturnHomePageButton>
    //                         <ReturnHomePage/>
    //                     </Styled.ReturnHomePageButton>
    //                 </Styled.ForgotPassword2Content>
    //             </Styled.ForgotPassword2Wrapper>
    //         </React.Fragment>
    //     );
    // }else{
    return (
        <React.Fragment>
            <Styled.ForgotPageWrapper>
                <Styled.ForgotPageContent>
                    <Styled.TitleComp>
                        <Styled.ForgotPageTitle data-testid={'forgotTitle'}>
                            YENİ ŞİFRE İSTEĞİ
                        </Styled.ForgotPageTitle>
                        <Link href={NavigationURLs.landing}>
                            <Styled.ForgotPageTitleLink>
                                Üye ol
                            </Styled.ForgotPageTitleLink>
                        </Link>
                    </Styled.TitleComp>
                    <Styled.ForgotPageForm>
                        <Styled.ForgotPageFormTriangle/>
                        <InputComp
                            title={'E-posta veya Telefon Numarası:'}
                            placeholder={'E-posta veya Telefon Numarası'}
                            changeWriting={(event) => {
                                setEmail(event.target.value);
                            }}
                            value={email}
                            onKeyDown={(event: KeyboardEvent<HTMLInputElement>) => {
                                if (event.key === 'Enter') {
                                    alertValidate();
                                }
                            }}
                            handleAlertClose={handleAlertClose}
                            data-testid={'emailOrPhoneNumber'}
                        />
                        {alert && <CustomAlert message={alert.message} type={alert.type}/>}
                    </Styled.ForgotPageForm>
                    <Styled.StyledForgotButton>
                        <ContinueButton
                            onClickFunction={() => {
                                alertValidate();
                            }}
                            isRequested={isRequested}
                        />
                    </Styled.StyledForgotButton>
                    <Styled.StyledForgotLine/>
                    <Styled.NotMemberYet>
                        <TextArea>
                            <h2 data-testid={'notMemberYet'}>
                                Üye Değil misiniz?
                            </h2>
                            <p data-testid={'ppInfoMessage'}>
                                Pembe Panjur ile mutluluğu yakalamak artık daha kolay! Ücretsiz kayıt olun, karakter
                                analizi testimizle size uygun üyelerle iletişime geçin.
                            </p>
                            <p data-testid={'ppInfoMessage2'}>
                                Güvenle giriş yapın, profiliniz gizli kalsın.
                            </p>
                        </TextArea>
                        <RegisterNow/>
                    </Styled.NotMemberYet>
                </Styled.ForgotPageContent>
            </Styled.ForgotPageWrapper>

        </React.Fragment>
    );
    // }


}


export default ForgotPageComp;
